<template>
    <div class="new-cars-in-stock__slide">
        <div class="new-cars-in-stock__card rd-card rd-card--no-padding">
            <a v-if="pictureCount <= 0" :href="link" class="new-cars-in-stock__img-link" @click.stop="gaTag('New Details', 'New Vehicles In Stock Card Clicked', 'Title')">
                <div class="new-cars-in-stock__bg-img new-cars-in-stock__bg-img--4-by-3" :style="{ 'background-image': 'url(' + backgroundImage + ')' }"></div>
                <picture>
                    <source media="(min-width: 992px)" :srcset="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                    <source srcset="/images/used/image-coming-soon.webp, /images/used/image-coming-soon@2x.webp 2x" type="image/webp" />
                    <img
                        class="new-cars-in-stock__img"
                        srcset="/images/used/image-coming-soon.jpg, /images/used/image-coming-soon@2x.jpg 2x"
                        itemprop="thumbnail"
                        :alt="'Used ' + vehicle.vehicle_title + ' Photo Coming Soon'"
                    />
                </picture>
                <div class="vehicle__reserved-bg" v-if="vehicle.reserved != null">
                    <img src="/images/used/reserved-logo.png" srcset="/images/used/reserved-logo.png, /images/used/reserved-logo@2x.png 2x" alt="This vehicle has now been reserved" class="img-responsive vehicle__reserved-img" />
                    <div class="vehicle__reserved-text">This car has now been <span class="vehicle__reserved-bold">reserved</span></div>
                </div>
            </a>
            <a v-else :href="link" class="new-cars-in-stock__img-link" @click.stop="gaTag('New Details', 'New Vehicles In Stock Card Clicked', 'Title')">
                <div class="new-cars-in-stock__bg-img new-cars-in-stock__bg-img--4-by-3" :style="{ 'background-image': 'url(' + backgroundImage + ')' }"></div>
                <picture>
                    <source media="(min-width: 992px)" :srcset="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                    <img class="new-cars-in-stock__img" :srcset="vehicle.used_vehicles_internal_images[0].thumbnail_path" alt="" />
                </picture>
                <div class="vehicle__reserved-bg" v-if="vehicle.reserved != null">
                    <img src="/images/used/reserved-logo.png" srcset="/images/used/reserved-logo.png, /images/used/reserved-logo@2x.png 2x" alt="This vehicle has now been reserved" class="img-responsive vehicle__reserved-img" />
                    <div class="vehicle__reserved-text">This car has now been <span class="vehicle__reserved-bold">reserved</span></div>
                </div>
            </a>

            <div class="new-cars-in-stock__spacer"></div>
            <div class="new-cars-in-stock__title-row">
                <a :href="link" class="new-cars-in-stock__title-area" @click.stop="gaTag('New Details', 'New Vehicles In Stock Card Clicked', 'Title')">
                    <h4 class="new-cars-in-stock__title">{{ vehicle.manufacturer }} {{ vehicle.model }}</h4>
                    <h5 class="new-cars-in-stock__subtitle">{{ vehicle.version }}</h5>
                </a>
                <div class="new-cars-in-stock__save-vehicle">
                    <!-- <input type="checkbox" value="" class="save-to-compare" :id="'compare-' + vehicle.id"
                        name="save-to-compare" v-model="inCompareList" />
                    <label :for="'compare-' + vehicle.id" class="new-cars-in-stock__save-vehicle-button">
                        <svg :class="{ 'new-cars-in-stock__save-vehicle-icon': true, 'new-cars-in-stock__save-vehicle-icon--active': inCompareList }"
                            width="32" height="29" viewBox="0 0 32 29" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M31 9.2C31 4.7 27.4 1.1 22.9 1.1 20 1.1 17.4 2.7 16 5 14.6 2.7 12 1.1 9.1 1.1 4.6 1.1 1 4.7 1 9.2 1 11.6 2.1 13.8 3.8 15.3L15.3 26.8C15.5 27 15.7 27.1 16 27.1 16.3 27.1 16.5 27 16.7 26.8L28.2 15.3C29.9 13.8 31 11.6 31 9.2Z" />
                        </svg>
                    </label> -->
                </div>
            </div>

            <div class="new-cars-in-stock__card-inner">
                <hr class="new-cars-in-stock__hr" />

                <div class="new-cars-in-stock__prices-container">
                    <div class="new-cars-in-stock__prices">
                        <a
                            :href="link"
                            class="new-cars-in-stock__price"
                            @click.stop="gaTag('New Details', 'New Vehicles In Stock Card Clicked', 'Cash Price')"
                        >
                            Cash Price
                            <span class="new-cars-in-stock__price-label">&pound;{{ vehicle.price_formatted }}</span>
                            <span class="pricing-area__vat-price" v-if="vehicle.vat_type == 'vat'">+VAT</span>
                        </a>
                        <!-- <div class="new-cars-in-stock__price" v-if="finance == 'loading'">
                            Per Month
                            <span class="new-cars-in-stock__per-month-error">
                                <div class="loading"><img src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading Results" /></div>
                            </span>
                        </div>
                        <div class="new-cars-in-stock__price" v-else-if="finance == 'out-of-range' || !finance">
                            Per Month
                            <span class="new-cars-in-stock__per-month-error">
                                Ask about finance
                            </span>
                        </div>
                        <a v-else :to="financeLink" class="new-cars-in-stock__price" @click.stop="gaTag('New Details', 'New Vehicles In Stock Card Clicked', 'Finance')">
                            Per Month
                            <span class="new-cars-in-stock__per-month-label">&pound;{{ monthlyPayment }}</span>
                        </a> -->
                    </div>
                    <!-- <auto-trader-value-rating class="new-cars-in-stock__at-rating-container" :rating="vehicle.value_rating" :classes="{ 'at-lg-value-img': true, 'hidden-xs': true }"></auto-trader-value-rating> -->
                </div>

                <hr class="new-cars-in-stock__hr" />

                <div class="new-cars-in-stock__spec">{{ keySpec }}</div>

                <div class="new-cars-in-stock__dealer" v-if="dealerName !== null">
                    <img src="/images/used/used-pin.svg" alt="Map pin" class="new-cars-in-stock__pin" />
                    {{ dealerName }}
                </div>

                <a :href="link" class="btn btn--primary-inverted btn--full-width" @click.stop="gaTag('New Details', 'New Vehicles In Stock Card Clicked', 'View Details Button')">
                    View Details
                </a>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        vehicle: {
            required: true
        }
    },
    data() {
        return {
            dealerName: null
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('match-height');
        });
    },
    created() {
        window.LocationDataLoader.get().then(dealers => {
            for (let index = 0, len = dealers.length; index < len; index++) {
                const dealer = dealers[index];
                if (dealer.id == this.vehicle.location_id) {
                    this.dealerName = dealer.name;
                    return;
                }
            }
        }).catch(error => {
            console.error(error);
        })
    },
    computed: {
        link() {
            return '/new-cars-in-stock/' + this.vehicle.id + '/' + this.vehicle.slug;
        },
        backgroundImage() {
            if (this.pictureCount > 0) {
                return this.vehicle.used_vehicles_internal_images[0]?.thumbnail_path || false;
            }

            return "/images/used/image-coming-soon@2x.jpg";
        },

        pictureCount() {
            if (this.vehicle.used_vehicles_internal_images) {
                return this.vehicle.used_vehicles_internal_images.length;
            }
            return 0;
        },
        priceWas() {
            return parseFloat(this.vehicle.price_was);
        },
        priceWasFormatted() {
            return numberFormat(this.priceWas, 0);
        },
        priceSave() {
            return parseFloat(this.vehicle.price_save);
        },
        priceSaveFormatted() {
            return numberFormat(this.priceSave, 0);
        },
        keySpec() {
            const keySpec = [];
            keySpec.push(this.shortTransmission);
            if (this.vehicle.no_doors) {
                keySpec.push(this.vehicle.no_doors + ' doors');
            }
            if (this.vehicle.body) {
                keySpec.push(this.vehicle.body);
            }
            if (this.vehicle.vehicle_reg_letter) {
                keySpec.push(this.vehicle.vehicle_reg_letter + ' Plate');
            }
            if (this.vehicle.fuel_type != '') {
                keySpec.push(this.vehicle.fuel_type);
            }
            if (this.mpg > 0) {
                keySpec.push(this.mpg + 'mpg');
            }
            return keySpec.join(' | ');
        },
        shortTransmission() {
            const transmission = String(this.vehicle.transmission).toLowerCase();
            if (transmission == 'automatic') {
                return 'Auto';
            }
            if (transmission == 'manual') {
                return 'Manual';
            }
            return this.vehicle.transmission;
        },
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/new-vue/components/details/NewCarsInStockCard.vue